import axios from 'axios';

export const httpClientSettings = axios.create({
  baseURL: process.env.REACT_APP_API_URL_SETTINGS,
});
